type TType = {
  __typename?: string;
}

export const omitTypename = <T extends TType>(obj: T): Omit<TType, '__typename'> => {
  const clone = { ...obj };
  delete clone.__typename;
  return clone;
}